// Action Types
export const SET_SYSTEM_MESSAGES = 'SET_SYSTEM_MESSAGES';

// Action Creators
export const setSystemMessages = (messages) => ({
    type: SET_SYSTEM_MESSAGES,
    payload: messages,
});
